export const checkPendingJobLoans = (gameData) => {
    var deleteLoanIdx = [];
    // move loans from pending loan table to gameData loanTable if loan date is prior to current game date
    for (let i = 0; i < gameData.pendingJob.loanTable.length; i++) {
        if (gameData.pendingJob.loanTable[i].loanStartDate <= gameData.currentGameDate) {
            gameData.loanTable.push(gameData.pendingJob.loanTable[i]);
            deleteLoanIdx.push(i);
        }
    }
    let startIdx = deleteLoanIdx.length - 1;
    for (let i = startIdx; i >= 0; i--) {
        gameData.pendingJob.loanTable.splice(deleteLoanIdx[i], 1);
    }
}
export default checkPendingJobLoans;